import React from 'react';
import css from '@emotion/css';
import styled from '@emotion/styled';
import Icon from '../assets/checked.svg';

const Checkbox = ({
  checked,
  children,
  bigger = false,
  className,
  ...props
}: any) => {
  return (
    <Label className={className}>
      <Box checked={checked} bigger={bigger}>
        {checked && (
          <IconWrap bigger={bigger}>
            <Icon />
          </IconWrap>
        )}
      </Box>
      <RealCheckbox type="checkbox" checked={checked} {...props} />
      {children && <Content>{children}</Content>}
    </Label>
  );
};

const Label = styled.label`
  display: flex;
  align-items: center;
  user-select: none;
`;

interface IIcon {
  bigger?: boolean;
}

interface IBox extends IIcon {
  checked?: boolean;
}

const Box = styled.div<IBox>`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  width: 16px;
  height: 16px;
  margin-right: 7px;
  border-radius: 3px;
  background-color: #d0d0d0;
  ${({ checked = false }) =>
    checked &&
    css`
      background-color: #0a62ba;
    `}
  ${({ bigger }) =>
    bigger &&
    css`
      width: 25px;
      height: 25px;
    `};
`;

const IconWrap = styled.div<IIcon>`
  display: flex;
  & svg {
    width: 10px !important;
  }
  user-select: none;
  ${({ bigger = false }) =>
    bigger &&
    css`
      & svg {
        width: 13px !important;
        height: 10px !important;
      }
    `};
`;

const RealCheckbox = styled.input`
  display: none;
`;

const Content = styled.span`
  opacity: 0.8;
  font-size: 14px;
  font-weight: 500;
  line-height: 0.93;
  color: #1e1e1e;
  html[color-mode='dark'] & {
    color: white;
  }
`;

export default Checkbox;
